import { Outlet } from 'react-router-dom';
import { Logo } from '@reed/design-system';

const TERMS_URL = 'https://www.reed.ai/terms-and-conditions';
const PRIVACY_URL = 'https://www.reed.ai/privacy-policy';

export default function BrandedOnboardingLayout(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-surface-alternate bg-auth-radial text-text-alternate">
      <header className="border-b border-border-alternate/20">
        <div className="mx-auto flex h-16 w-full max-w-[1440px] items-center px-4 sm:px-6 xl:px-10">
          <a
            href="/"
            aria-label="Reed.ai home"
            className="rounded-s focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-border-alternate"
          >
            <Logo theme="light" size="sm" />
          </a>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[1440px] flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-border-alternate/20">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col items-start justify-between gap-2 px-4 py-6 text-xs text-text-alternate sm:flex-row sm:items-center sm:px-6 xl:px-10">
          <p>&copy; {new Date().getFullYear()} Reed.ai Limited. All rights reserved.</p>
          <nav className="flex gap-4">
            <a
              href={PRIVACY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-s hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-border-alternate"
            >
              Privacy
            </a>
            <a
              href={TERMS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-s hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-border-alternate"
            >
              Terms
            </a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
